import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const deleteConfigurationUseCase = async (firmwareId: string) => {
  try {
    const state = store.getState();
    const namespace = state?.yourSlice?.authContext?.customerNamespace;

    const response = await apiUseCases.deleteConfiguration(
      namespace,
      firmwareId,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to delete configuration")
        .message,
    };
  }
};
